import { cloneElement, type FC, type ReactNode } from 'react';
import { QFlex } from '../../../QLayouts';
import { usePartitionedChildren } from '../../../utils';

export const QSelectPlaceholder: FC<{ children?: ReactNode }> = ({
  children,
}) => {
  const { QIcon: icon, QText: text } = usePartitionedChildren(
    children,
    'QIcon',
    'QText',
  );

  return text.length ? (
    <QFlex alignItems={'center'}>
      {icon.length ? <QFlex mr={1}>{icon}</QFlex> : null}
      {cloneElement(text[0], { color: 'gray.500' } as never)}
    </QFlex>
  ) : null;
};

QSelectPlaceholder.displayName = 'QSelectPlaceholder';
